import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 260;

export const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        display: "flex",
      },
      notifyContent: {
        Width: "380px",
      },
      newTxt: {
        border: "1px solid #E8EFF6",
        color: "#283941",
        borderRadius: 10,
        padding: "2px 5px",
      },
      readMessage: {
        background: "#F8F8F8",
        "& h6, p": {
          color: "#5E6066",
        },
      },
      // left menu style
      menuList: {
        padding: 0,
        borderRadius: 0,
      },
      MuiListItemText: (props) => {
        const textColor =
          props.appTheme === "CLASSIC"
            ? "#231F20"
            : props.appTheme === "LIGHT"
            ? "#29678D"
            : "#C2BDBD";
        return {
          color: textColor,
          "& span": {
            fontSize: 14,
          },
        };
      },
      menuItemIcon: {
        display: "flex",
        alignItems: "center",
        padding: "12px 30px",
        textDecoration: "none",
        minWidth: 45,
        "& img": {
          width: 24,
          height: 24,
          objectFit: "contain",
          filter: "brightness(0) invert(0.3)",
        },
        "& .MuiListItemIcon-root": {
          minWidth: 46,
        },
      },
      collapseBtn: {
        padding: "20px 8px 20px 20px",
        justifyContent: "start",
        color: "#C2BDBD",
        height: 64,
        transition: "all 0.5s",
        position: "relative",
        "&:before": {
          content: "'←'",
          position: "absolute",
          opacity: 0,
          top: 7,
          left: -20,
          transition: "0.5s",
          fontSize: 26,
        },
        "&:hover": {
          paddingLeft: 65,
          paddingRight: 8,
          "&:before": {
            opacity: 1,
            left: 24,
          },
        },
        [theme.breakpoints.down("xs")]: {
          height: 57,
        },
        "& img": {
          width: 24,
          marginRight: 20,
        },
        "& span": {
          display: "inline-flex",
        },
      },
      // appbar -- header style
      appBar: {
        left: "64px",
        zIndex: "9 !important",
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: `calc(100% - 64px) !important`,
        [theme.breakpoints.down("xs")]: {
          left: "54px",
          width: `calc(100% - 54px) !important`,
        },
        "& .MuiToolbar-regular": {
          height: 65,
          paddingRight: 30,
          paddingLeft: 30,
          [theme.breakpoints.down("xs")]: {
            height: 56,
            paddingRight: 20,
            paddingLeft: 10,
          },
        },
      },
      appBarShift: {
        marginLeft: `calc(${drawerWidth}px - 64px) !important`,
        width: `calc(100% - ${drawerWidth}px) !important`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("xs")]: {
          marginLeft: "0 !important",
          width: "calc(100% - 54px) !important",
        },
      },
      hide: {
        display: "none",
      },
      toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
      },
      grow: {
        flexGrow: 1,
      },
      logo: {
        width: "105px",
        display: "block",
      },
      menuButton: {
        height: 65,
        justifyContent: "flex-start",
        position: "fixed",
        zIndex: 1,
        background: "#fff",
        borderRadius: 0,
        padding: "12px 30px",
        left: 0,
        top: 0,
        "&:hover": {
          background: "#fff",
        },
        "@media only screen (min-width:375px) and (max-width:812px) and (-webkit-device-pixel-ratio: 3)":
          {
            visibility: "visible",
            opacity: 1,
            zIndex: 9999,
            position: "fixed",
          },
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
          background: "#fff",
          borderRadius: 0,
          // width: 70,
          height: 56,
          margin: 0,
          padding: "12px 14px",
          "&:hover": {
            background: "#fff",
          },
        },
      },
      collapseBtn: (props) => {
        const collapseBtnColor =
          props.appTheme === "CLASSIC"
            ? "#231F20"
            : props.appTheme === "LIGHT"
            ? "#29678D"
            : "#C2BDBD";
        return {
          color: collapseBtnColor,
          fontSize: 14,
          fontFamily: `"Poppins", sans-serif`,
          margin: "0 0 5px 8px",
        };
      },
      menu: (props) => {
        const menuBgColor =
          props.appTheme === "CLASSIC"
            ? "#231F20"
            : props.appTheme === "LIGHT"
            ? "#29678D"
            : "#C2BDBD"; // update color as per theme
        return {
          width: 26,
          height: 45,
          position: "relative",
          margin: "12px 0",
          transform: "rotate(0deg)",
          transition: ".5s ease-in-out",
          cursor: "pointer",
          "& span": {
            display: "block",
            position: "absolute",
            height: 2,
            width: 26,
            background: menuBgColor,
            borderRadius: 9,
            opacity: 1,
            left: 0,
            transform: "rotate(0deg)",
            transition: ".25s ease-in-out",
            "&:nth-child(1)": {
              top: 10,
            },
            "&:nth-child(2)": {
              top: 20,
              width: 16,
            },
            "&:nth-child(3)": {
              top: 30,
            },
          },
          [theme.breakpoints.down("xs")]: {
            margin: 0,
          },
        };
      },
      isOpen: {
        "& $menu": {
          "& span": {
            background: "#B4B4B4",
            "&:nth-child(1)": {
              top: 18,
              transform: "rotate(135deg)",
            },
            "&:nth-child(2)": {
              opacity: 0,
              // left: -60,
            },
            "&:nth-child(3)": {
              top: 18,
              transform: "rotate(-135deg)",
            },
          },
        },
      },
      title: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
          display: "block",
        },
      },
      sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
          display: "flex",
          alignItems: "center",
        },
      },
      sectionMobile: {
        display: "flex",
        [theme.breakpoints.up("md")]: {
          display: "none",
        },
      },
      avatarBtn: {
        padding: "2px",
        textTransform: "capitalize",
        minWidth: "auto",
        "& span": {
          fontSize: 14,
          color: "#777777",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          "& svg": {
            fontSize: 18,
          },
        },
        "& .avatar-img": {
          margin: 0,
        },
      },
      userName: {
        "& img": {
          width: 10,
          marginLeft: 6,
        },
      },

      headerMenu: (props) => {
        const iconColor =
          props.appTheme === "CLASSIC"
            ? "#777"
            : props.appTheme === "LIGHT"
            ? "#a5a5a5"
            : "#B8D0EC";
        return {
          padding: "8px",
          margin: "0 15px 0 0",
          "& button": {
            margin: "0 14px",
            padding: 0,
            "& svg": {
              color: iconColor,
              fontSize: 24,
            },
          },
        };
      },
      divider: {
        borderLeft: "solid 2px rgb(112 112 112 / 35%)",
        height: 25,
        paddingLeft: 8,
      },
      // drawer style
      drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        // marginTop: -80,
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
        },
        "& .Mui-selected": {
          borderRadius: 0,
          borderRight: "solid 3px #EF7713",
        },
      },
      drawerOpen: {
        zIndex: 99999,
        width: drawerWidth,
        // boxShadow: '0px 3px 6px #00000029',
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
          "& .MuiIconButton-root": {
            borderBottom: "none",
            width: "auto",
          },
        },
        "& .MuiIconButton-root": {
          width: drawerWidth,
          border: "none",
          boxShadow: "0px -5px 6px #00000029",
          "&:hover": {
            // background: "none",
            border: "none",
          },
        },
      },
      drawerClose: {
        zIndex: 9,
        width: 0,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        [theme.breakpoints.down("xs")]: {
          width: 0,
          border: 0,
        },
      },
      paper: {
        background: "none",
        border: "none",
        position: "unset",
      },
      moreBtn: {
        padding: 0,
      },
      content: {
        flexGrow: 1,
        marginTop: 80,
        [theme.breakpoints.down("xs")]: {
          marginTop: 70,
        },
      },
      companySetupHeader: {
        left: "0",
        width: "100% !important",
        [theme.breakpoints.down("xs")]: {
          paddingLeft: 16,
        },
      },
      closeIcon: {
        transition: ".3s",
        color: "#CCCCCC",
        marginTop: -5,
        "&:hover": {
          background: "#eee",
        },
      },
      mobileMenuName: {
        margin: "0 0 0 5px",
      },
      mobileMenuIcon: {
        color: "#777",
        margin: "0 8px",
      },
      mobileMenuDivider: {
        borderBottom: "dashed 1px #c5c4c4",
        display: "block",
        width: "100%",
      },
      headerNotifList: {
        [theme.breakpoints.down("xs")]: {
          "& li": {
            margin: "5px 0",
            minHeight: "auto",
          },
        },
      },
      navList: {
        background: "#fff",
        marginTop: -15,
        [theme.breakpoints.down("xs")]: {
          marginTop: -24,
        },
      },
      navListOpen: {
        width: drawerWidth,
        position: "fixed",
        // top: 0,
        left: 0,
        // paddingTop: 65,
        background: "#fff",
        boxShadow: "0px 3px 6px #00000029",
        height: "100vh",
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      navListClose: {
        width: 0,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      targetImg: {
        minWidth: 20,
        width: 20,
        height: 20,
        display: "block",
        objectFit: "contain",
      },
      targetBackground: {
        background: "#E3E8F2",
        width: 36,
        height: 36,
        minWidth: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px 5px",
        borderRadius: 100,
        marginRight: 10,
        position: "relative",
      },
      noBackground: {
        width: 36,
        height: 36,
        minWidth: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px 5px",
        borderRadius: 100,
        marginRight: 10,
        position: "relative",
      },
      userImg: {
        width: 36,
        height: 36,
        minWidth: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 100,
        marginRight: 10,
        position: "relative",
      },
      smallIcon: {
        position: "absolute",
        top: -6,
        right: -7,
      },
      expandIcon: {
        color: "#A1A3A6",
      },
      expandMenu: {
        display: "flex",
        justifyContent: "space-between",
        "&.Mui-selected": {
          borderRight: "none",
        },
      },
      subMenu: {
        "& .MuiButtonBase-root": {
          paddingLeft: 46,
          "& a": {
            padding: "6px 30px",
          },
        },
        "& .Mui-selected": {
          background: "#F8F7F8",
        },
      },
    };
  },

  { index: 1 }
);
